export const isFullDay = (startISO: string, endISO: string) =>
  new Date(endISO).valueOf() - new Date(startISO).valueOf() >= 86400000; // 24 * 60 * 60 * 1000
